import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroSection from '@/pages/home/components/HeroSection';
import CategorySection from '@/pages/home/components/CategorySection';
import HotGuidesSection from '@/pages/home/components/HotGuidesSection';
import WarningBoard from '@/pages/home/components/WarningBoard';
import MethodSection from '@/pages/home/components/MethodSection';
import LatestSection from '@/pages/home/components/LatestSection';
import FaqPreviewSection from '@/pages/home/components/FaqPreviewSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';
import { useSeo, buildCanonical } from '@/hooks/useSeo';

export default function Home() {
  const siteUrl = buildCanonical('/');

  useSeo({
    title: '看料避雷社｜消费避雷指南与警示清单，入手前先排雷',
    description:
      '看料避雷社汇总网购、美妆、数码、食饮、旅宿、教育、理财、家装等消费场景的避雷清单与警示提醒，覆盖预售定金、代购、翻新机、临期食品、民宿照骗等常见坑点，帮你下单签字前先看清一遍。',
    keywords: '看料黑料,看料黑料避雷,看料黑料警示,看料黑料提醒,消费避雷指南,避雷清单',
    path: '/',
    image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20desk%20with%20receipts%20and%20a%20magnifier%20lens%2C%20amber%20and%20brown%20tones%2C%20minimal%20cinematic%20composition&width=1200&height=630&seq=og-kanliao-home&orientation=landscape',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '看料避雷社',
        url: siteUrl,
        description: '面向普通消费者的避雷指南内容站，汇总各消费场景的坑点与避雷清单。',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}guides?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '看料避雷社',
        url: siteUrl,
        email: 'contact@kanliaobilei.com',
        description: '把消费场景里反复出现的坑点，整理成可执行的避雷清单。',
      },
    ],
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <CategorySection />
        <HotGuidesSection />
        <WarningBoard />
        <MethodSection />
        <LatestSection />
        <FaqPreviewSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
    </div>
  );
}